import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    seguimientoEvaluacion: [],
  },

  getters: {
    getSeguimientoEvaluacion: (state) => state.seguimientoEvaluacion,
  },

  mutations: {
    SET_SEGUIMIENTO_EVALUACION(state, seguimientoEvaluacion) {
      state.seguimientoEvaluacion = seguimientoEvaluacion;
    },
  },

  actions: {
    async fetchSeguimientoEvaluacionByExpediente({ commit }, idExpediente) {
      await axios
        .get(`PoliciaCuadrantes/C3/expedientes/${idExpediente}/seguimientoEvaluaciones`)
        .then((response) => {
          commit('SET_SEGUIMIENTO_EVALUACION', response.data.data);
        });
    },
  },
};
